<template>
<div>

<compFormEdit ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData"  :labelWidth="120"></compFormEdit>
  <vButtonGroup class="text-right">
          <vButton @click="submit" theme="primary">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
          <vButton @click="cancel">{{$t('global.common.cancel', { defaultValue: "取消" })}}</vButton>
  </vButtonGroup>
  <vLoading loading size="large" transfer v-if="loading"></vLoading>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
    HttpSaveForwarderPort,
    HttpForwarderPortGetOne
} from "@/service/basicdata";
export default {
  props: ["activeid","type"],
  created() {
    this.getDetail();
  },
  data() {
    return {
      loading: false,
      id:  this.activeid,
      addressCodeList:[],
      formData: {
      },
      required: [
        {
          required: true,
          message: "该信息不能为空,请填写"
        }
      ],
    };
  },
  computed: {
      ...mapGetters('dictionary', ['getSystemPortList']),
       
      isQuery() {
          return this.type === "query";
      },
        
      isAdd() {
        return this.type === 'add'
      },
     getBase() {
			return [{
              label: this.$t('fbb.headlogistics.ship_port',{defaultValue:'系统发运港口'}),
              key: "logisticsportId",
              query:this.isQuery,
              tag:'vSelect',
              span:24,
              options:this.getSystemPortList,
              on: {
              'on-attach': attach => {
                this.formData.code = attach.code;
                this.formData.title =attach.title
              }
              }
              },{
              label: this.$t('fbb.basic.port_address',{defaultValue:'港口地址'}),
              key: "address",
              span:24,
              query:this.isQuery,
              tag:'vInput',
              },{
              label: this.$t('bi.work.task_principal_name',{defaultValue:'负责人'}),
              required:false,
              query:this.isQuery,
              span:24,
              key: "contactName",
              tag:'vInput',
              },{
              label: this.$t('fbb.inbound.contact_phone',{defaultValue:'联系电话'}),
              required:false,
              query:this.isQuery,
              span:24,
              key: "contactPhone",
              tag:'vInput',
              },{
              label: this.$t('global.common.notes',{defaultValue:'备注'}),
              key: "meta",
              query:this.isQuery,
              span:24,
              required:false,
              tag:'vTextarea',
              }
      ];
     }
        
  },
  methods: {
      getDetail() {
      if (this.isAdd) return;
      this.loading = true;
      if(this.id){
          HttpForwarderPortGetOne({ id: this.id }).then(res => {
					
          this.formData = res.data;
          	this.loading = false;
				}).catch(err => {
					this.loading = false;
					this.$VMessage.error(err.message);
				})
      }
    },
    
    async submit(){
        const valid = await this.$refs.formbase.validate();
        if (!valid) return;
        this.loading = true;
        HttpSaveForwarderPort({
         ...this.formData
        })
          .then(res => {
            this.loading = false;
            this.$VMessage.success(this.$t('fbb.logistics.cost_add_success', { defaultValue: '添加成功' }));
            this.success();
          }, err => {
            this.loading = false;
                this.$VMessage.error(err.message)
            });
    },
   
    success() {
      this.$emit("on-close");
      this.$emit("on-update");
      this.$emit("refreshPage");
    },
    cancel() {
      this.$emit("on-close");
    }
  }
};
</script>
